module.exports = __webpack_public_path__ + "img/logo-full.31ab009.svg";